import { Auth } from '../dashboards'
import { Channel } from 'frontendcommon-3'
import { useShellStart } from './shell-start'
import { useShellStore } from '@/store'
import { ref, computed, nextTick, onMounted } from 'vue'

export function useAgreement (modalRef) {
  const shellStore = useShellStore()
  const agreementProps = computed(() => shellStore.agreementProps)
  const agreementConfig = ref()

  const { updateAuthData } = useShellStart()

  function setModelValue (value) {
    shellStore.SET_AGREEMENT_PROPS({ modelValue: !!value })
  }

  function setProps (props) {
    shellStore.SET_AGREEMENT_PROPS(props)
  }

  function setPlan (plan) {
    shellStore.SET_AGREEMENT_PROPS({ plan })
  }

  async function onTypeFormComplete () {
    setModelValue(false)
    shellStore.SET_FULL_LOADER(true)
    await new Promise((resolve) => setTimeout(resolve, 2000)) // Wait 2 seconds
    await refreshShell()
    document.body.dispatchEvent(new CustomEvent('nextera:onboarding-tour')) // Start Usetiful tour
    shellStore.SET_FULL_LOADER(false)
  }

  function onUpdateConfig (config) {
    if (agreementConfig.value) return
    agreementConfig.value = config
    // Init Usetifull
    const auth = new Auth()
    auth.initUsetifull({
      micros: shellStore.micros,
      agreementConfig: config
    })
  }

  async function refreshShell () {
    const auth = new Auth()
    const authData = await auth.getAuthData(false, true)
    await modalRef.value.refresh()
    updateAuthData(authData)
    await nextTick()
  }

  onMounted(() => {
    const channel = new Channel()
    channel.onShellAgreement(({ detail: plan }) => {
      setProps({ modelValue: !!plan, plan })
    })
  })

  return {
    agreementProps,
    setModelValue,
    setProps,
    setPlan,
    onTypeFormComplete,
    onUpdateConfig
  }
}
